const handleAlphaNumericCheck = (event) => {
    if ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122 || event.charCode >= 48 && event.charCode <= 57)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
    // if (event.charCode >= 48 && event.charCode <= 57) {
    //     return true
    //   } else {
    //     event.preventDefault()
    //     return false
    //   }
  };
  
  export default handleAlphaNumericCheck;

  